import { friendlyApiErrorMessage } from 'src/app/services/api-error-notifier.service';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { Subscription } from "rxjs/internal/Subscription";
import { HttpClient } from '@angular/common/http';
import { ApiService } from 'src/app/services/api.service';
import { FilterService } from 'src/app/services/filter.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { ActivatedRoute } from '@angular/router';
import { forkJoin } from 'rxjs';
import { Observable } from 'rxjs';
import { PixelMapComponent } from "../../shared/charts/pixel-map/pixel-map.component";

@Component({
    selector: 'app-pixel-map-card',
    templateUrl: './pixel-map-card.component.html',
    styleUrls: ['./pixel-map-card.component.scss'],
    standalone: false
})
export class WidgetPixelMapCardComponent implements OnInit {
  static key = 100819;

  @Input("item") item: any;
  @Input("pageKey") pageKey: any;

  @Output("onSizeChange") onSizeChange = new EventEmitter<any>();
  @ViewChild("PixelMapDiv", { static: true }) PixelMapDiv!: ElementRef;
  @ViewChild(PixelMapComponent) pixelMapComponent!: PixelMapComponent;

  config: any;
  data: any;
  reqSubcription: Subscription[] = [];
  isDataLoaded = false;
  sourceName: any;
  parentData: any
  childData: any;

  dashboardKey: any;

  // Pagination State
  public totalRecords: number = 0;
  public currentStartIndex: number = 0;
  public loadedData: any[] = [];
  public loadedPatientCount: number = 0; // Track number of unique patients loaded
  public paginationPageSize: number = 500; // Default, will be updated from config

  public isChildPageLoading: boolean = false;
  public currentPageIndex: number = 0;

  public currentFilterQuery: string = ''; // --- NEW PROPERTY ---
  public error_name: any;

  constructor(
    private filterService: FilterService,
    private route: ActivatedRoute,
    private httpClient: HttpClient,
    private apiService: ApiService,
    private navigationService: NavigationService
  ) {

    this.route.params.subscribe((p: any) => {
      // Query Params
      this.route.queryParams.subscribe((params: any) => {
        let decryptedParams = this.navigationService.decryptData(params);
        this.dashboardKey = decryptedParams["ds_key"];
      });
    });

    this.reqSubcription.push(
      this.filterService.filterQuery.subscribe((query: any) => {
        console.log(`[PixelMapCard] Filter Query Update. Fetching initial buffer.`);
        // Reset pagination since filter was changed
        // Reload data with new query
        // Reset pagination?
        this.pixelMapComponent.resetPages();
        this.currentStartIndex = 0;
        this.currentPageIndex = 0;
        this.loadedData = [];
        this.loadedPatientCount = 0;
        this.pendingRanges = []; // Clear pending

        this.isChildPageLoading = true; // --- Show Spinner ---
        // Ensure we fetch enough for the first TWO pages (sliding window start)
        this.loadApiData(0, this.paginationPageSize * 2, false);
        // this.getcommentsData();
      })
    );
  }

  ngOnInit(): void {
    this.item;

    const observer = new ResizeObserver((e: any) => {
      this.onSizeChange.emit(e[0].contentRect.height);
    });
    observer.observe(this.PixelMapDiv.nativeElement);
    this.loadlineConfig();
    // this.loadApiData();
  }

  loadlineConfig() {
    const cfg = this.item?.['config'];
    if (cfg && cfg["default_pagenation"]) {
      this.paginationPageSize = Number(cfg?.["default_pagenation"] ?? 500);
    }
  }

  private pendingRanges: { start: number, end: number }[] = [];
  private outOfOrderBuffer: Map<number, { data: any[], patientCount: number }> = new Map();

  loadApiData(startIndex: number = 0, pageSize: number = 1000, isBackground: boolean = false, params: any = {}) {
    const requestEnd = startIndex + pageSize;
    // Check if this EXACT request is already pending to avoid duplicates
    const isDuplicate = this.pendingRanges.some(r => r.start === startIndex && r.end === requestEnd);
    if (isDuplicate) {
      console.log(`[PixelMapCard] Skipping duplicate request: ${startIndex}-${requestEnd}`);
      return;
    }
    this.pendingRanges.push({ start: startIndex, end: requestEnd });

    console.log(`[PixelMapCard] loadApiData: start=${startIndex}, size=${pageSize}, bg=${isBackground}`);

    const apiConfig = this.item.config || {};
    const parentApiKey = apiConfig["status_code_lookup_key"] ?? 200242;
    const childApiKey = apiConfig["transactions_key"] ?? 200241;

    const totatlCountKey = apiConfig["total_count_key"] ?? 200243;

    // GET PAYLOAD DATA
    const payloadData = JSON.parse(sessionStorage.getItem("payloadData") || '{}');

    // if (!this.filterService.isEmptyObject(this.filterService.baseQuery)) {
    const commonQuery = {
      ...this.filterService.baseQuery,
      report_typ: 'D',
      time_cycle: this.filterService.report_type,
      report_key: undefined,

      "filter_query": this.currentFilterQuery || null,
      pat_seq_sub_cat_key: null,
      ...payloadData, // if coming from upset this will override the null value of pat_seq_sub_cat_key
      // 3. SPREAD PARAMS LAST: This allows the passed object to override EVERYTHING above
      ...params
    };

    console.log("params", params);

    const parentQuery = { ...commonQuery, api_key: parentApiKey, pageSize: pageSize.toString(), startIndex: startIndex };
    const childQuery = { ...commonQuery, api_key: childApiKey };
    const totalCountQuery = { ...commonQuery, api_key: totatlCountKey };
    const apiEndpoint = this.item.config?.["widget_endpoint"] || "pss/get-pss-data";

    const parentRequest: Observable<any[]> = this.httpClient.post<any[]>(
      `${this.apiService.apiBaseUrl}/${apiEndpoint}`,
      parentQuery
    );

    const childRequest: Observable<any[]> = this.httpClient.post<any[]>(
      `${this.apiService.apiBaseUrl}/${apiEndpoint}`,
      childQuery
    );

    const totalCountRequest: Observable<any[]> = this.httpClient.post<any[]>(
      `${this.apiService.apiBaseUrl}/${apiEndpoint}`,
      totalCountQuery
    );

    const subscription = forkJoin([parentRequest, childRequest, totalCountRequest]).subscribe({
      next: ([parentRes, childRes, totalCountRes]: [any[], any[], any[]]) => {
        this.error_name = '';
        this.removePendingRange(startIndex, requestEnd);

        // Update Total Records from API Response
        if (totalCountRes && totalCountRes.length > 0 && totalCountRes[0].patient_count !== undefined) {
          this.totalRecords = Number(totalCountRes[0].patient_count);
        }

        // If the request that just finished covers the current page, stop loading
        const currentPageStart = this.currentStartIndex; // This might be old if we are jumping?
        // Actually, we should check if the *current view* is waiting for this data.
        // But since we don't track "current view page index" explicitly in the parent (only in child),
        // we can rely on the fact that if we just loaded data that covers the "currentStartIndex" (which we update below),
        // then we are good.

        // Wait, we update currentStartIndex below.
        // Let's just set loading to false if we are not background?
        // Or better: re-evaluate based on pending ranges?

        // Simple approach: If this was a foreground fetch, stop loading.
        if (!isBackground) {
          this.isChildPageLoading = false;
        } else {
          // If it was background, we might still be loading if the user navigated to it.
          // We need to check if the *current* page is now fully loaded.
          // But we don't know the current page index here easily without storing it.
          // However, `getData` will update the child.
          // Let's assume if we have data, we are good?
          // Actually, if the user is on Page 3 (pending), and this request finishes Page 3,
          // we should stop loading.

          // We can just set isChildPageLoading = false whenever a request finishes?
          // No, because another request might be pending for the *actual* current page.
          // But usually we only fetch one range at a time or sequential.

          // Let's just set it to false. If there are other pending requests for the *current* page,
          // onPageChange would have set it to true? No, onPageChange only runs on click.

          // If we are here, we just received data.
          // If this data corresponds to what the user is looking at, we stop loading.
          // Since we don't know exactly what the user is looking at (child has `currentPage`),
          // we can try to be conservative.

          // If `pendingRanges` is empty, definitely stop loading.
          if (this.pendingRanges.length === 0) {
            this.isChildPageLoading = false;
          } else {
            // Check if the CURRENT page is now loaded
            const pageSize = this.paginationPageSize;
            const requiredStart = this.currentPageIndex * pageSize;
            const requiredEnd = requiredStart + pageSize;

            const bufferStart = this.currentStartIndex;
            const bufferEnd = bufferStart + this.loadedPatientCount;

            if (requiredStart >= bufferStart && requiredEnd <= bufferEnd) {
              this.isChildPageLoading = false;
            }
          }
        }

        this.parentData = parentRes || [];
        const newChildData = childRes || [];

        // Assuming the API returns the total count in a header or a specific field. 
        // If not, we might need to adjust this. For now, let's assume we get it or just use a large number if unknown.
        // Ideally, the API response should include metadata. 
        // Since the current implementation expects an array, I'll stick to that but we might need to check if the response is wrapped.
        // For this task, I'll assume the array length is what we get, but we need a way to know total records.
        // If the API doesn't return total count, we can't know for sure, but we can guess if we got full page.
        // For this task, I'll assume the array length is what we get, but we need a way to know total records.
        // If the API doesn't return total count, we can't know for sure, but we can guess if we got full page.

        // NOTE: In a real scenario, we'd parse totalRecords from response. 
        // Here I will simulate it or check if the user provided info about it. 
        // The user said "fetch the next 500 rows".

        if (!isBackground) {
          this.childData = newChildData;
          this.loadedData = [...newChildData];
          this.currentStartIndex = startIndex;
          // We assume the API returns exactly pageSize number of patients (or less if end of data)
          // Since we don't have exact count from API metadata, we estimate based on request
          // If we requested 500 patients, we assume we got 500 unless the data seems empty/small?
          // Actually, we can't know for sure without grouping, but for the sliding window logic,
          // we just need to know "we covered the range [startIndex, startIndex + pageSize]".
          this.loadedPatientCount = new Set(this.loadedData.map((d: any) => d.patient_key)).size;
          this.outOfOrderBuffer.clear(); // Clear buffer on new foreground load

          // If we fetched less than requested, that's the end.
          // If we fetched less than requested, that's the end.
          // this.totalRecords = 10000; // Placeholder - Now fetched from API
        } else {
          // Append logic
          const expectedStart = this.currentStartIndex + this.loadedPatientCount;
          console.log(`[PixelMapCard] Background Load: start=${startIndex}, size=${newChildData.length}, expected=${expectedStart}, currentStart=${this.currentStartIndex}, loadedCount=${this.loadedPatientCount}`);

          // Relaxed Check: Allow append if startIndex is close to expectedStart (handling minor API count discrepancies)
          // But ensure we don't append if we missed a whole page (gap >= pageSize)
          const isContiguous = startIndex >= expectedStart && startIndex < expectedStart + pageSize;

          if (isContiguous) {
            console.log(`[PixelMapCard] Contiguous append (or close enough). Appending ${newChildData.length} rows.`);
            // Contiguous! Append.
            this.loadedData = [...this.loadedData, ...newChildData];
            const oldCount = this.loadedPatientCount;
            this.loadedPatientCount = new Set(this.loadedData.map((d: any) => d.patient_key)).size;
            console.log(`[PixelMapCard] Appended. Patient Count: ${oldCount} -> ${this.loadedPatientCount}`);

            // Check buffer for next chunks
            let nextStart = this.currentStartIndex + this.loadedPatientCount;
            // We need to be careful with nextStart now. If we had a gap, nextStart might not match buffer keys exactly.
            // But buffer keys are based on requested startIndex (e.g. 500, 1000).
            // So we should check if we have data for the "next logical page".
            // If we just appended Page 1 (500), next logical is 1000.
            // But nextStart might be 999.
            // We should check for keys >= nextStart and < nextStart + pageSize?

            // Simplified buffer check: Iterate keys?
            // Or just check the specific key we expect (e.g. startIndex + pageSize)?
            const nextLogicalStart = startIndex + pageSize;
            if (this.outOfOrderBuffer.has(nextLogicalStart)) {
              console.log(`[PixelMapCard] Found buffered data for ${nextLogicalStart}`);
              const buffered = this.outOfOrderBuffer.get(nextLogicalStart);
              if (buffered) {
                this.loadedData = [...this.loadedData, ...buffered.data];
                this.loadedPatientCount = new Set(this.loadedData.map((d: any) => d.patient_key)).size;
                this.outOfOrderBuffer.delete(nextLogicalStart);
              }
            }
          } else if (startIndex > expectedStart) {
            console.warn(`[PixelMapCard] Gap detected! Buffering. start=${startIndex} > expected=${expectedStart}. Data Size: ${newChildData.length}`);
            // Gap! Buffer it.
            this.outOfOrderBuffer.set(startIndex, { data: newChildData, patientCount: pageSize });
          } else if (startIndex < this.currentStartIndex) {
            console.log(`[PixelMapCard] Prepending.`);
            // Prepending logic (if needed, but for now we reset if jumping back far)
            this.loadedData = [...newChildData, ...this.loadedData];
            this.currentStartIndex = startIndex;
            this.loadedPatientCount = new Set(this.loadedData.map((d: any) => d.patient_key)).size;
          }
        }

        this.getData();
      },
      error: (err: any) => {
        this.removePendingRange(startIndex, requestEnd);
        this.isChildPageLoading = false; // Stop loading on error
        if (!isBackground) {
          this.parentData = [];
          this.childData = [];
          this.loadedData = [];
          this.getData();
        }
        this.error_name = friendlyApiErrorMessage(err);
      }
    });

    this.reqSubcription.push(subscription);
    // }
  }

  private removePendingRange(start: number, end: number) {
    this.pendingRanges = this.pendingRanges.filter(r => !(r.start === start && r.end === end));
  }

  private isRangeAvailableOrPending(start: number, end: number): boolean {
    // Check loaded data
    const bufferStart = this.currentStartIndex;
    const bufferEnd = bufferStart + this.loadedPatientCount;

    // Relaxed Check: Allow if we have at least 90% of the requested data?
    // Or just check if we cover the start?
    // If we are missing the last few items, it's likely an API count issue.
    // Let's say if we cover up to end - 50 (10% of 500).
    const tolerance = 50;
    const isAvailable = start >= bufferStart && (end - tolerance) <= bufferEnd;

    if (!isAvailable) {
      console.log(`[PixelMapCard] Range Check FAIL: Request ${start}-${end} NOT in Buffer ${bufferStart}-${bufferEnd} (Tolerance: ${tolerance})`);
    }

    if (isAvailable) {
      return true;
    }

    // Check pending ranges
    // We consider it available if a pending range COVERS the requested range
    // Or if multiple pending ranges cover it? For simplicity, let's check if ANY pending range covers it
    // or if the requested range is fully contained within the union of buffer + pending.
    // For this specific issue (Page 3 loading), we just need to know if the specific page is pending.

    // Simple check: is there a pending range that covers this request?
    const isPending = this.pendingRanges.some(r => r.start <= start && r.end >= end);
    return isPending;
  }

  onPageChange(pageIndex: number) {
    this.currentPageIndex = pageIndex;
    const pageSize = this.paginationPageSize;
    const requiredStart = pageIndex * pageSize;
    const requiredEnd = requiredStart + pageSize;

    // Check if we have this data in our loaded buffer OR if it is pending
    if (this.isRangeAvailableOrPending(requiredStart, requiredEnd)) {
      // We have the data (or it's coming)!

      // Update loading state based on whether it's pending or actually loaded
      const bufferStart = this.currentStartIndex;
      const bufferEnd = bufferStart + this.loadedPatientCount;
      const isLoaded = requiredStart >= bufferStart && requiredEnd <= bufferEnd;

      this.isChildPageLoading = !isLoaded; // If it's pending but not loaded, show loader.

      // Do we need to fetch the NEXT page in background?
      const nextNextPageStart = (pageIndex + 1) * pageSize;
      const nextNextPageEnd = nextNextPageStart + pageSize;

      // Check if next page is available or pending
      // Note: We use bufferEnd from current state for "available", but for "pending" we check ranges.
      // We should fetch if it's NOT available AND NOT pending.

      // If next page is NOT in buffer AND NOT pending, fetch it.
      // We can reuse isRangeAvailableOrPending but we need to be careful.
      // isRangeAvailableOrPending checks if *requested* range is covered.

      if (!this.isRangeAvailableOrPending(nextNextPageStart, nextNextPageEnd)) {
        // We don't have the next page and it's not being fetched, fetch it!
        // We fetch starting from where our current buffer ends (append) OR just the specific page?
        // The original logic was `this.loadApiData(bufferEnd, pageSize, true);`
        // But bufferEnd might be old if we are jumping.
        // Safer to fetch exactly what we need:
        this.loadApiData(nextNextPageStart, pageSize, true);
      }
    } else {
      // We don't have the data and it's not pending.
      // Fetch it immediately (blocking/loading state)
      // Fetch current page + next page (buffer)
      this.isChildPageLoading = true;
      this.loadApiData(requiredStart, pageSize * 2, false);
    }
  }

  onPageSizeChange(newPageSize: number) {
    // Optimization: If we already have the data for the new page size, don't re-fetch.
    // Calculate where we are currently
    const currentAbsStart = this.currentPageIndex * this.paginationPageSize;

    // Calculate new page index to stay on the same record
    const newPageIndex = Math.floor(currentAbsStart / newPageSize);

    const requiredStart = newPageIndex * newPageSize;
    const requiredEnd = requiredStart + newPageSize;

    // Check if this range is available in our current buffer
    if (this.isRangeAvailableOrPending(requiredStart, requiredEnd)) {
      // We have the data! Just update state and notify child.
      this.paginationPageSize = newPageSize;
      this.currentPageIndex = newPageIndex;

      // We need to tell the child to update its page index
      if (this.pixelMapComponent) {
        this.pixelMapComponent.setPage(newPageIndex);
      }
    } else {
      // Data not available, standard reset
      this.paginationPageSize = newPageSize;
      // Reset to first page when page size changes (or we could try to fetch newPageIndex?)
      // User expectation usually is reset or stay. Let's reset if we can't support the current view.
      this.currentStartIndex = 0;
      this.loadedData = [];
      this.loadedPatientCount = 0;
      this.loadApiData(0, newPageSize, false);
    }
  }

  getData() {
    if (this.parentData?.length && this.loadedData?.length) {
      this.data = this.loadedData;
    } else if (!this.loadedData?.length) {
      this.data = [];
    } else if (!this.parentData?.length) {
      this.data = this.loadedData;
    }
  }

  ngOnDestroy(): void {
    this.reqSubcription.forEach((res) => res.unsubscribe());
  }

  serverSideSearch(filterSearchParam: any) {
    this.loadApiData(0, this.paginationPageSize * 2, false, filterSearchParam);
  }

  onFilterQueryChange(param: any) {
    console.log('[PixelMapCard] Filter Query Changed:', param);
    // this.currentFilterQuery = param;
    // Reload data with new query
    // Reset pagination?
    this.currentStartIndex = 0;
    this.currentPageIndex = 0;
    this.loadedData = [];
    this.loadedPatientCount = 0;
    this.pendingRanges = []; // Clear pending

    this.isChildPageLoading = true; // --- Show Spinner ---
    this.loadApiData(0, this.paginationPageSize * 2, false, param);

    // Reset child component page to 0
    if (this.pixelMapComponent) {
      this.pixelMapComponent.setPage(0);
    }
  }

}
